/** Rutas relativas al prefijo `/inventario`. */
export const inventoryPaths = {
  itemNew: 'nuevo',
  itemEdit: ':id',
  movements: 'movimientos',
  locations: 'ubicaciones',
  /** Legacy — subcategorías (acceso directo por URL). */
  subcategories: 'subcategorias',
} as const;
